import styled from "styled-components";

export const UltimaAtualizacaoText = styled.p`
  color: var(--neutral-light);
  font-size: 0.875rem;
  font-style: italic;
  margin: 0 0 16px 0;
`;
